import React from 'react';
import styles from './index.module.css';

const RadioPill = ({ name, value, label, checked, onChange }) => (
  <label className={checked ? `${styles.label} ${styles.checked}` : styles.label}>
    <input
      type='radio'
      className={styles.input}
      name={name}
      value={value}
      checked={checked}
      onChange={() => onChange(value)}
    />
    <span className={styles.text}>{label}</span>
  </label>
);

export default RadioPill;
